export { default } from './ConfirmEducation.jsx';
